import { render, staticRenderFns } from "./FeishuBind.vue?vue&type=template&id=f2e4171a&scoped=true"
import script from "./FeishuBind.vue?vue&type=script&lang=js"
export * from "./FeishuBind.vue?vue&type=script&lang=js"
import style0 from "./FeishuBind.vue?vue&type=style&index=0&id=f2e4171a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e4171a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2e4171a')) {
      api.createRecord('f2e4171a', component.options)
    } else {
      api.reload('f2e4171a', component.options)
    }
    module.hot.accept("./FeishuBind.vue?vue&type=template&id=f2e4171a&scoped=true", function () {
      api.rerender('f2e4171a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/login/FeishuBind.vue"
export default component.exports